'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _constants = require('../../../src/constants');

var _utils = require('../../utils');

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

var _CaseSmsMediaItem = require('./CaseSmsMediaItem');

var _CaseSmsMediaItem2 = _interopRequireDefault(_CaseSmsMediaItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ACTIVITY_STATUS_CLASSNAMES = _constants.AppConstants.ACTIVITY_STATUS_CLASSNAMES;
var formatPhoneNumber = _utils.FormattingUtils.formatPhoneNumber;


var TITLES = {
  'inbound': 'SMS Received',
  'outbound': 'SMS Sent',
  'unknown': 'SMS'
};

var CaseSms = (_dec = (0, _mobxReact.inject)('CaseStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSms, _Component);

  function CaseSms() {
    _classCallCheck(this, CaseSms);

    return _possibleConstructorReturn(this, (CaseSms.__proto__ || Object.getPrototypeOf(CaseSms)).apply(this, arguments));
  }

  _createClass(CaseSms, [{
    key: 'renderTitle',
    value: function renderTitle() {
      var direction = (0, _get3.default)(this.props.activity, 'direction', 'unknown').toLowerCase();
      return _react2.default.createElement(
        'h3',
        null,
        TITLES[direction]
      );
    }
  }, {
    key: 'renderMedia',
    value: function renderMedia() {
      var _props$activity = this.props.activity,
          media = _props$activity.sms.media,
          status = _props$activity.status,
          isDownloadingMedia = status && status.toLowerCase() === 'downloading media',
          hasMedia = !!media && !!media.length;


      if (!isDownloadingMedia && !hasMedia) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        isDownloadingMedia && _react2.default.createElement(
          _Row2.default,
          { className: 'status' },
          'Downloading media...'
        ),
        hasMedia && _react2.default.createElement(
          _Row2.default,
          { className: 'files' },
          _react2.default.createElement(
            'ul',
            null,
            media.map(function (mediaItem, idx) {
              return _react2.default.createElement(
                'li',
                { key: idx },
                _react2.default.createElement(_CaseSmsMediaItem2.default, { mediaItem: mediaItem })
              );
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$activity2 = this.props.activity,
          _props$activity2$sms = _props$activity2.sms,
          body = _props$activity2$sms.body,
          to_number = _props$activity2$sms.to_number,
          direction = _props$activity2.direction,
          status = _props$activity2.status,
          sentSms = (direction || '').toLowerCase() === 'outbound',
          statusClassName = status && ACTIVITY_STATUS_CLASSNAMES[status.toLowerCase()],
          activity_body = _react2.default.createElement(
        'div',
        null,
        this.renderTitle(),
        sentSms && _react2.default.createElement(
          _Row2.default,
          { className: 'status' },
          _react2.default.createElement(
            'h4',
            null,
            'Status:'
          ),
          ' ',
          _react2.default.createElement(
            'span',
            { className: statusClassName },
            status
          )
        ),
        sentSms && _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h4',
            null,
            'To:'
          ),
          ' ',
          formatPhoneNumber(to_number)
        ),
        body && _react2.default.createElement(
          _Row2.default,
          { className: 'bloc' },
          body
        ),
        this.renderMedia()
      );

      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: activity_body,
        dot: 'icon',
        icon: 'mobile'
      }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseSms;
}(_react.Component), _class2.propTypes = {
  activity: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = CaseSms;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ACTIVITY_STATUS_CLASSNAMES, 'ACTIVITY_STATUS_CLASSNAMES', '/app/src/components/common-activities/CaseSms.js');
  reactHotLoader.register(formatPhoneNumber, 'formatPhoneNumber', '/app/src/components/common-activities/CaseSms.js');
  reactHotLoader.register(TITLES, 'TITLES', '/app/src/components/common-activities/CaseSms.js');
  reactHotLoader.register(CaseSms, 'CaseSms', '/app/src/components/common-activities/CaseSms.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/CaseSms.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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